
import Vue from 'vue';

import { post, fetch, Del, put } from "../../../../ask/axios";
import wcaPopup from '@/components/reception/reg/wcaPopup.vue'
import { elAlert } from "@/utils/bulletBox";
export default {
  name: "indexPage",
  //组件引用
  components: { wcaPopup },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      //票数选择
      surRadio: null,
      surItem: [{ val: 1, label: '<5', }, { val: 2, label: '5-15', }, { val: 3, label: '16-30', }, { val: 4, label: '30+', }],
      //发货方式
      chkVal: [],
      surChkItem: [
        { val: 3, label: 'Air freight' }, { val: 1, label: 'Express' }, { val: 5, label: 'LCL' }, { val: 20, label: 'FBA' }, { val: 2, label: 'International packet' },
      ],
      //从哪里知道百运
      promoteValue: '',
      regPromote: [],

      //公司名称
      Company: '',
      //公司输入提示
      CompanyMsg: '',
      IsCompany: false,
      //名称
      Name: '',
      NameMsg: '',
      IsNameMsg: false,
      //邮箱
      EmailId: '',
      EmailIdMsg: '',
      IsEmailId: false,
      //密码
      Password: '',
      PasswordMsg: '',
      IsPassword: '',


      Investigation: false,
      Agreement: false, //显示协议
      //注册信息提示
      showchkval: false,
      showRadio: false,
      RegisterShow: true,
      //注册信息ID
      OrderID: '',
      //验证码
      Verification: '',
      databaes64: '',
      dataKey: '',
      Verification: '',
      ValidateCode: '',
      IsVerificationCode: false,
      VerificationCodeMsg: '',

      checked: false,

      // 弹框显示
      isShowPop: false,


    }
  },

  created() { //创建后

  },
  mounted() { //dom已经生成
    this.VerificationCode();
    this.KnowBy();
    if (this.$route.query.Email) {
      this.EmailId = this.$route.query.Email;
      this.Investigation = false;
      this.RegisterShow = true;
    }
    if (this.$route.query.EmailId) {
      this.OrderID = this.$route.query.EmailId
    }

  },
  computed: {
    //计算属性周期函数


  },
  methods: {

    //点击平均发货票数
    changeChkItem(val) {
      this.showchkval = false;
    },
    danji() {
      this.showRadio = false;
    },
    //验证码接口
    VerificationCode() {
      let that = this;
      that.api.param = {}
      // that.api.url = this.$api02 + "/api/EbayCustomer/ImageCode/CreateImage";
      that.api.url = this.$api04 + "/Basics/api/ImageCode/CreateImage";

      let sendDate=(new Date()).getTime();

      fetch(that.api.url, that.api.param).then(function (res) {
        let receiveDate = (new Date()).getTime();
        let responseTimeMs = receiveDate - sendDate;
        //that.clkVerify(res.IsOK,res.Message,responseTimeMs)

        if (res.IsOK) {
          that.databaes64 = res.Results.Data
          that.dataKey = res.Results.CheckCodeKey
          that.ValidateCode = res.Results.ValidateCode
        }
      })
    },
    //判断是否输入验证码
    IsVerification() {
      if (this.Verification == null || this.Verification == '') {
        this.IsVerificationCode = true;
        this.VerificationCodeMsg = 'Please enter the validation code';
        return false;

      } else {
        this.IsVerificationApi();
      }
    },
    //验证验证码
    IsVerificationApi() {
      let that = this;
      that.api.param = {
        checkCodeKey: that.dataKey,
        validateCode: that.Verification
      }
      that.api.url = this.$api02 + "/api/EbayCustomer/ImageCode/GetCheckCodeIF";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          that.VerificationCodeMsg = res.Message;
          that.IsVerificationCode = false;
          return true;
        } else if (res.Results == false) {
          that.VerificationCodeMsg = 'Validation code error or expired';
          that.IsVerificationCode = true;
          return false;
        }

      })
    },
    //验证公司名称
    IsCompanyId() {
      var regle = /^.{1,50}$/;
      if (this.Company == null || this.Company == '') {
        this.IsCompany = true;
        this.CompanyMsg = 'Company name is required'
      } else {
        if (!regle.test(this.Company)) {
          this.IsCompany = true;
          this.CompanyMsg = 'Company name is required'
        } else {
          this.existence2();
          this.IsCompany = false;
          return this.IsCompany;
        }
      }

    },
    //验证名称
    IsName() {
      var regle = /^[\u4e00-\u9fa5\w]{6,50}$/;
      if (this.Name == null || this.Name == '') {
        this.IsNameMsg = true;
        this.NameMsg = 'Name is required'
      } else {
        if (!regle.test(this.Name)) {
          this.IsNameMsg = true;
          this.NameMsg = 'Company name is required'
        } else {
          this.IsNameMsg = false;
          return this.Name;
        }
        this.IsNameMsg = false;
        this.NameMsg = ''
      }
    },
    //验证邮箱并添加未完成注册信息
    IsEmail() {
      var regEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.EmailId == null || this.EmailId == '') {
        this.IsEmailId = true;
        this.EmailIdMsg = 'Working email is required'
      } else {
        if (!regEmail.test(this.EmailId)) { //只能输入邮箱格式
          this.EmailId = '';
          this.IsEmailId = true;
          this.EmailIdMsg = 'Please enter a valid email address'
        } else {
          //this.IsEmail=true;
          this.IsEmailId = false;
          this.existence1();
          //this.NextStepapi();
          return this.EmailId
        }
      }
    },
    //验证是否邮箱
    IsEmailcheck() {
      var regEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!this.EmailId) {
        this.IsEmailId = true;
        this.EmailIdMsg = 'Working email is required'
      } else {
        if (!regEmail.test(this.EmailId)) { //只能输入邮箱格式
          this.EmailId = '';
          this.IsEmailId = true;
          this.EmailIdMsg = 'Please enter a valid email address'
        } else {
          this.IsEmail = true;
          this.IsEmailId = false;

          return this.EmailId
        }
      }
    },
    //验证密码
    IsPasswordA() {
      var reg = /^.{6,20}$/;
      if (this.Password == null || this.Password == '') {
        this.IsPassword = true;
        this.PasswordMsg = 'Password is required'
      } else {
        this.IsPassword = false;
        this.PasswordMsg = ''
        if (!reg.test(this.Password)) { //只能输入邮箱格式
          this.Password = '';
          this.IsPassword = true;
          this.PasswordMsg = 'Please enter 6-20 characters using alphanumeric, numeric or symbolic.'
        } else {
          this.IsPassword = false;
          this.PasswordMsg = ''
          return this.Password
        }
      }
    },
    //打开协议
    AgreementShow() {
      this.Agreement = true
    },
    //  //注册未完成信息
    //  NextStepapi(){
    //   let that= this;
    //   if(!this.$route.query.EmailId){
    //     that.api.param={
    //       OutStorePiece:that.surRadio,
    //       BusinessTypeStr:that.chkVal,
    //       VisitEmail:that.EmailId,
    //       Origin:1
    //     }
    //     that.api.url=this.$api02+"/api/EbayCustomer/CusRegInfo/AddCusRegInfo";
    //     post(that.api.url,that.api.param).then(function (res) {
    //       if(res.IsOK==true){
    //        that.OrderID=res.Results.Id;
    //       }
    //     })
    //   }
    //     that.OrderID=that.$route.query.EmailId
    //   },
    //注册api
    submitInfo(popVal) {
      //console.log(popVal)
      // 从弹框里取出的字段
      let { customerOwnerType, wcaID, isWca } = popVal
      let param = {
        "Email": this.EmailId,
        "CompanyName": this.Company,
        "Name": this.Name,
        "Password": this.Password,
        "CusRegInfoID": this.OrderID,
        "OutStorePiece": this.surRadio,
        "BusinessTypeList": this.chkVal,
        "KnowBY": this.promoteValue,
        Origin: 1,
        IsWCA: isWca,
        WCAID: wcaID,
        CustomerOwnerType: customerOwnerType,
        "anonymousId":sensors.quick('getAnonymousID'),
      }
      let url = this.$api02 + "/api/EbayCustomer/CustomerRegist/RegistEn";
      post(url, param).then( (res)=> {
        let Message=''
        if(res.Message){
          Message=res.Message
        }
        //this.regResult(res.IsOK,Message) //埋点
        this.registerSyncApi(res)

        if (res.IsOK == true) {
          //注册成功
          this.$router.push({path:'/reg/emailAct',query: {Email:this.EmailId,AccountID:res.Results.UserId}})
          //window.location.href = "/reg/emailAct?Email=" + this.EmailId + '&AccountID=' + res.Results.UserId
        } else {
          this.$refs.wcaPop.clsoeAll() //关闭所有弹窗
          elAlert(this, "error");
        }
      })
    },

    registerSyncApi(item){ //埋点传服务端接口
      let that=this
      let Message=""
      if(item.IsOK){
        Message=item.Message
      }
      let anonymousId=sensors.quick('getAnonymousID')
      that.Isregister=true; //注册中
      that.api.param={
        registration:"注册客户",
        is_success:item.IsOK,
        fail_reason:Message,
        app_name:"电商Web端",
        platform_type:"web", //手机验证码
        is_login:false,//第三方注册来源
        UserId:item.Results.UserId,
        anonymousId:anonymousId,
      }
      that.api.url=this.$api02+"/api/EbayCustomer/CustomerRegist/RegisterSync";
      post(that.api.url,that.api.param).then(function (res) {
       
      })
    },
    existence1() {
      let that = this;
      that.api.param = {
        LoginName: that.EmailId,
        Email: that.EmailId
      }
      // that.api.url = this.$api02 + "/api/EbayCustomer/CustomerRegist/RegistVerify";
      that.api.url = this.$api04+"/Basics/api/CustomerRegist/RegistVerify";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          //邮箱样式
          that.IsEmailId = false;
        } else {
          //邮箱样式
          that.IsEmailId = true;
          that.EmailIdMsg = 'The Mailbox has been registered by another user'
          return false;
        }
      })
    },
    existence2() {
      let that = this;
      that.api.param = {
        CompanyName: that.Company,
      }
      // that.api.url = this.$api02 + "/api/EbayCustomer/CustomerRegist/RegistVerify";
      that.api.url = this.$api04+"/Basics/api/CustomerRegist/RegistVerify";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          //邮箱样式
          that.IsCompany = false;
        } else {
          //邮箱样式
          that.IsCompany = true;
          that.CompanyMsg = 'The company name has been registered by another user.'
          return false;
        }
      })
    },
    //提交注册验证
    Submitzc() {
      let that = this;
      that.IsCompanyId();
      that.IsName();
      that.IsEmailcheck();
      that.IsPasswordA();
      that.IsVerification();
      if (!that.EmailId || !that.Company || !that.Password || !that.Name || !that.Verification || that.IsVerificationCode == true) {
        return false
      }

      if (that.Company) {
        that.existence2(); //调用接口验证公司名称是否重复
      }
      if (that.EmailId) {
        that.existence1(); //调用接口验证邮箱是否重复
      }

      if (that.checked != true) {
        that.$confirm("Do you agree to the service terms of Freightshop?", "", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          that.checked = true  //点击yes,
        })
          .catch(() => { });
        return false;
      }
      this.$refs.wcaPop.open()

      //this.clkButton() //埋点
    },
    //从哪里知道百运
    KnowBy() {
      let that = this;
      that.api.param = {
        useInfo: 1
      },
        // that.api.url = that.$api02 + "/api/EbayCustomer/KnowBY/QueryKnowBYList";
        that.api.url = that.$api04 + "/Basics/api/KnowBY/QueryKnowBYList";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {

          that.regPromote = res.Results;
        }
      })
    },

    //服务协议弹框方法
    getClose() { //关闭弹框
      // this.checked=true;
      this.Agreement = false
    },
    Agreementend() { //同意协议
      this.checked = true;
      this.Agreement = false
    },
  }

}





// WEBPACK FOOTER //
// ./src/assets/js/reception/reg/registerCst.js